import { CanDeactivateFn } from '@angular/router';

interface PlanEditorDeactivationAware {
    canDeactivate?: () => boolean;
}

export const planEditorUnsavedChangesGuard: CanDeactivateFn<
    PlanEditorDeactivationAware
> = (component) => {
    if (!component?.canDeactivate) {
        return true;
    }

    return component.canDeactivate();
};
